<template>
	<div>
		<header-page
			name="customers-new"
			:title="$route.meta.title"
		/>
		<customer-form
			:customer-id="id"
		/>
	</div>
</template>

<script>
	import customerForm from '@/components/customers/customer-form';

	export default {
		name: 'page-customer-new',
		components: {
			customerForm,
		},
		props: {
			id: [Number, String],
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/customers/page-customer-new.vue